import React from 'react';

const smallTitleRegexGlobal = /\|.*?\|/g; // matches |desired small-title text|
const smallTitleCaptureRegex = /\|(.*?)\|/; // captures |desired small-title text|
const italicTitleRegexGlobal = /!.*?!/g; // matches !desired italic-title text!
const italicTitleCaptureRegex = /!(.*?)!/; // captures !desired italic-title text!
const breakRegexGlobal = /\n/g; // matches :linebreak:
const breakCaptureRegex = /\n/; // captures :linebreak:

const SPLIT_CHAR = '%%&&';

const generateStyledOutput = () => (potentialStyledOutput, index) => {
  const smallTitleMatchResult = potentialStyledOutput.match(
    smallTitleCaptureRegex
  ); // yields |desired small-title text|

  const italicTitleMatchResult = potentialStyledOutput.match(
    italicTitleCaptureRegex
  ); // yields !desired italic-title text!

  const breakMatchResult = potentialStyledOutput.match(breakCaptureRegex); // yields :linebreak:

  if (smallTitleMatchResult) {
    const copy = smallTitleMatchResult[1];

    return (
      <h1 className="small-title__content" key={`small-title-${index}`}>
        {copy}
      </h1>
    );
  }

  if (italicTitleMatchResult) {
    const copy = italicTitleMatchResult[1];

    return (
      <span className="italic-title__content" key={`italic-title-${index}`}>
        {copy}
      </span>
    );
  }

  if (breakMatchResult) {
    return <br />;
  }

  // content is not in styled format!
  return potentialStyledOutput;
};

export default (content) => {
  if (typeof content === 'string') {
    // Wrap all styled output in a split character
    const bookmarkedString = content
      .replace(
        smallTitleRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        italicTitleRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        breakRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      );
    // Split on split char and map everything you can to styled output
    const result = bookmarkedString
      .split(SPLIT_CHAR)
      .map(generateStyledOutput());
    return result;
  }

  // not parsable
  return content;
};
